module.exports = __webpack_public_path__ + "static/media/export-icon.78426585.svg";